import { memoize, merge } from 'lodash-es';

import { Theme } from 'netline-ui';

import { getMainConfig } from './config';

const createDefaultTheme = ({ palette }: Theme) => ({
  appHeader: {
    appHeaderHeight: 44,
    dividerNextToCustomerLogoHeight: 32,
    backgroundColor: palette.common.black,
    elementHoverBackgroundColor: palette.grey[800],
    iconColor: palette.grey[500],
    dividerColor: palette.grey[50],
    productsMenu: {
      backgroundColor: palette.common.black,
      hoverBackgroundColor: palette.primary.main,
      iconColor: palette.grey[500],
    },
    preferencesMenu: {
      languageSelector: {
        hideFlags: false,
      },
    },
    text: {
      defaultTextColor: palette.grey[500],
      appTitleColor: palette.common.white,
    },
    userMenu: {
      userNameColor: palette.grey[500],
      avatarColor: palette.warning.light,
    },
    customerLogo: {
      logoHeight: 28,
      leftPadding: 12,
      rightPadding: 0,
      hideCustomerLogo: false,
    },
  },
  sidebar: {
    hideSidebarDividers: false,
  },
  aboutDialog: {
    airlineLogoHeight: 28,
    lufthansaSystemsLogoHeight: 14,
    tailLogoBottom: -28,
    tailLogoRight: 40,
    tailLogoHeight: 230,
  },
});

const getAppFrameTheme = memoize((theme: Theme) => {
  const { appHeader, sidebar, ...rest } = getMainConfig('theme') || {};

  return merge({}, createDefaultTheme(theme), {
    appHeader: appHeader === false ? { hidden: true } : appHeader,
    sidebar: sidebar === false ? { hidden: true } : sidebar,
    ...rest,
  });
});

export default getAppFrameTheme;
